import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../util/withRouter';
import moment from 'moment';
import _ from 'lodash';

import FormattedMessage from '../../../components/FormattedMessage';
import { getLocalePrice } from '../../../util/billingUtils';

// Import Style
import '../Billing.scss';

// Import Style

class SubscriptionPendingChanges extends Component {
  static defaultProps = {
    data: {}
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { app, data } = this.props;

    if (!data.scheduled) {
      return <div></div>;
    }

    return (
      <div className="white_box_details plan_info">
        <h3>Pending subscription</h3>

        <p>
          <span>Plan:</span> {data.scheduled.plan.name.replace(' Annual', '').replace(' New', '')}
        </p>
        <p>
          <span>Subscription type:</span> {data.scheduled.plan.period_unit === 'month' ? 'Monthly' : 'Annual'}{' '}
          subscription
        </p>
        {!!data.scheduled.plan.meta_data && (
          <p>
            <span>
              Number of <FormattedMessage id={`${app}.board`} prefix={app} mode="capitalize" plural="true" />:
            </span>{' '}
            {data.scheduled.plan.meta_data.allowed}
          </p>
        )}

        {data.scheduled.estimation.taxes && !!data.scheduled.estimation.taxes.length && (
          <p>
            <span>Amount:</span> {getLocalePrice(data.scheduled.estimation, data.scheduled.estimation.sub_total / 100)}
          </p>
        )}
        {data.scheduled.estimation.taxes &&
          data.scheduled.estimation.taxes.map((t, i) => {
            return (
              <p key={i}>
                <span>{t.description}:</span> {getLocalePrice(data.scheduled.estimation, t.amount / 100)}
              </p>
            );
          })}
        {data.scheduled.estimation.discounts &&
          data.scheduled.estimation.discounts.map((t, i) => {
            return (
              <p key={i}>
                <span>{t.description}:</span> {getLocalePrice(data.scheduled.estimation, t.amount / 100)}
              </p>
            );
          })}

        <p>
          <span>Total amount:</span> {getLocalePrice(data.scheduled.estimation, data.scheduled.estimation.total / 100)}
        </p>
        {data.customer.balances && !!data.customer.balances.length && (
          <p>
            <span>Credits:</span> {
              getLocalePrice(
                data.scheduled.estimation,
                data.customer.balances && data.customer.balances[0]
                  ? (data.customer.balances[0].promotional_credits + data.customer.balances[0].refundable_credits) / 100
                  : 0
              )
            }
          </p>
        )}
        <p>
          <span>Effective from:</span> {moment.unix(data.subscription.next_billing_at).format('DD MMM YYYY')}
        </p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app.app
  };
}

export default withRouter(connect(mapStateToProps)(SubscriptionPendingChanges));
